import { useState, useEffect, useMemo } from 'react';

import { GroupCell, CheckBoxCell } from './parts';
import { RBAC_UI_VIEWS_MAPPING } from '../../../constants/rbac';
import { TIERS } from '../../../constants/tiers';

export const useFormData = (allPermissions, permissions, accessibleFeatures, disabled) => {
  const [selectedPermissions, setSelectedPermissions] = useState(permissions);

  useEffect(() => {
    setSelectedPermissions(permissions);
  }, [permissions]);

  const onCheckBoxClick = (item, checked) => {
    const permissionClicked = TIERS
      .flatMap(permission => item[permission])
      .filter(permission => permission)
      .join('.');
    if (checked) {
      setSelectedPermissions([...selectedPermissions, permissionClicked]);
    } else {
      setSelectedPermissions(selectedPermissions.filter(permission => permission !== permissionClicked));
    }
  };

  const cols = [
    {
      display: 'Permissions',
      key: 'group',
      groupBy: TIERS,
      as: GroupCell,
    },
    {
      display: 'Allowed',
      key: 'allowed',
      reducer: values => values.reduce((acc, val) => acc + val.allowed, 0),
      as: CheckBoxCell,
      onClick: onCheckBoxClick,
      disabled,
    },
  ];

  const allPermissionsFiltered = useMemo(() => (
    allPermissions.filter(permission => {
      if (permission.includes('ui_views')) {
        return accessibleFeatures.includes(RBAC_UI_VIEWS_MAPPING[permission]);
      }
      return true;
    })
  ), [accessibleFeatures, allPermissions]);

  const permissionData = useMemo(() => (
    allPermissionsFiltered.map(permission => {
      const [permission_1, ...permissionParts] = permission.split('.');
      return {
        allowed: selectedPermissions.includes(permission) ? 1 : 0,
        tier_1: permission_1,
        tier_2: permissionParts[0] ? permissionParts[0] : null,
        tier_3: permissionParts[1] ? permissionParts[1] : null,
        tier_4: permissionParts[2] ? permissionParts[2] : null,
        tier_5: permissionParts[3] ? permissionParts[3] : null,
      };
    })
  ), [allPermissionsFiltered, selectedPermissions]);

  return {
    cols,
    permissionData,
    selectedPermissions,
    setSelectedPermissions,
  };
};
